module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "产品名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getProList(1)
            }
          },
          model: {
            value: (_vm.souchs.proName),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "proName", $$v)
            },
            expression: "souchs.proName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getProList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "200px",
            "label": "图片",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "min-width": "240",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "label": "单价(元/月)",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchasabled",
            "label": "是否可购买",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.purchasable == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "useful",
            "label": "是否作废",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.useful == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增产品",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入",
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(1)
            }
          },
          model: {
            value: (_vm.addForm.price),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "price", $$v)
            },
            expression: "addForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.purchasable),
            callback: function($$v) {
              _vm.purchasable = $$v
            },
            expression: "purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.useful),
            callback: function($$v) {
              _vm.useful = $$v
            },
            expression: "useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.checkedCities),
            callback: function($$v) {
              _vm.checkedCities = $$v
            },
            expression: "checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑产品",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeDialog
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(2)
            }
          },
          model: {
            value: (_vm.editForm.price),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "price", $$v)
            },
            expression: "editForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.purchasable),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "purchasable", $$v)
            },
            expression: "editForm.purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.useful),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "useful", $$v)
            },
            expression: "editForm.useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange2
          },
          model: {
            value: (_vm.editCheckedCities),
            callback: function($$v) {
              _vm.editCheckedCities = $$v
            },
            expression: "editCheckedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c82abe3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/productList/ProductList.vue
// module id = 1763
// module chunks = 9